import React, { useReducer } from 'react'
export const AuthContext = React.createContext({})

const initialState = {
  
}


const reducer = (state, action) => {
  switch (action.type) {
    case 'SET_PROFILE':
      return {
        ...state, ...(action.payload || {})
      }
    default:
      throw new Error()
  }
}


export const AuthContextProvider = (Children) => {
  const Provider = props => {
    const [state, dispatch] = useReducer(reducer, initialState)

    return (
      <AuthContext.Provider value={{...state, dispatch}}>
        <Children {...props} />
      </AuthContext.Provider>
    )
  }
  return Provider
}
